module.exports = __webpack_public_path__ + "static/young-adults-c6e7059cabf909e316fe6dbfd6225781.jpg";